// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1M1h_","resendInfoText":"OnGoingPaymentBox_resendInfoText__2o9Al"};